var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("mds-empty-state", {
    staticClass: "save-failure__response-message",
    attrs: { title: _vm.title, message: _vm.message },
    scopedSlots: _vm._u([
      {
        key: "mds-empty-state-icon",
        fn: function () {
          return [
            _c("mds-inline-message", {
              staticClass: "save-failure__check-mark",
              attrs: { variation: "informational", "icon-only": "" },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "mds-empty-state-actions",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "save-failure__actions" },
              [
                _c(
                  "mds-button",
                  {
                    attrs: { variation: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("change-name")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translate(
                            "scheduler.modal.save.failure.duplicate.button"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "mds-button",
                  {
                    staticClass: "save-failure__close-button",
                    attrs: { variation: "flat" },
                    on: {
                      click: function ($event) {
                        return _vm.onClick()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translate(
                            "scheduler.modal.save.failure.cancel.button"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }